import {Button, Col, FormGroup, Input, Row} from "reactstrap";
import React, {useState} from "react";
import {v4 as uuid4} from "uuid";

export const TableFilterEditRenderStatus = ({filter, applyFilter}) => {
  const [state, setState] = useState({
    id: filter?.id !== undefined ? filter.id : uuid4(),
    field: filter.field,
    operator: '=', // Always use equals operator for render status
    value: filter?.value !== undefined ? filter.value : '',
    label: filter?.label,
    type: filter?.type,
  });

  // RenderStatus options
  const renderStatusOptions = [
    {label: 'Published', value: 'PUBLISHED'},
    {label: 'Draft', value: 'DRAFT'},
    {label: 'Scheduled', value: 'SCHEDULED'},
    {label: 'Expired', value: 'EXPIRED'},
  ];

  return (<>
    <FormGroup className="mb-3">
      <Input
        type="select"
        className={'form-control'}
        value={state.value}
        onChange={e => setState({...state, value: e.target.value})}
      >
        <option value="" disabled>Select Render Status</option>
        {renderStatusOptions.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    </FormGroup>

    <Row>
      <Col>
        <Button
          className="btn-primary float-right"
          disabled={state.value === ''}
          outline={state.value !== ''}
          onClick={() => applyFilter({...state})}
        >
          Apply
        </Button>
      </Col>
    </Row>
  </>)
}
